import React, { useEffect, useState } from 'react'
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionBody, CAccordionHeader } from '@coreui/react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useLoaderData } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios'
import { cilSearch, cilTrash, cilPlus } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { confirmAlert } from 'react-confirm-alert'
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime'
import dayjs from 'dayjs';
import AsyncSelect from 'react-select/async'

const page = 1
const urlApi = '/work_graphs'
const urlRouter = '/work_graphs'

// хто увійшов
const role = localStorage.getItem('user_role')
// дані користувача
const userData = JSON.parse(localStorage.getItem('user_data'))

// перше завантаження
export async function LoaderWorkSchedules() {
   let query = `page=${page}`
   const request = `account.user.id=${userData.id}`

   // запит тільки даних користувача
   if (role === 'ROLE_ADMIN') {
      // console.log('запит адмін')
      let res = await AxiosInstance.get(`${urlApi}?${query}`).then((response) => {
         return response
      })
      return res
   } else {
      // console.log('запит партнера')
      let res = await AxiosInstance.get(`${urlApi}?${query}&${request}`).then((response) => {
         return response
      })
      return res
   }
}

// головний контент
const WorkPlans = () => {
   const { data } = useLoaderData() || { data: {} };

   const [rows, setRows] = useState(false)
   const [rowCountState, setRowCountState] = useState(0)
   const [showLoader, setShowLoader] = useState(false)

   //стейти для фільтра(перенесено з планів)
   const [partnerFilterSearch, setPartnerFilterSearch] = useState('')
   const [factoryFilterSearch, setFactoryFilterSearch] = useState('')
   const [disabled, setDisabled] = useState(true)
   const [resetFiltersFlag, setResetFiltersFlag] = useState(false)



   // Список можливих статусів
   // const optionsStatus = [
   //    { value: 'new', label: 'Нова' },
   //    { value: 'not_checked', label: 'Не перевірено' },
   //    { value: 'rejected', label: 'Зауваження' },
   //    { value: 'checked', label: 'Перевірено' },
   //    { value: 'synced', label: '1С' },
   // ];


   // const getRowsTable = (p = 1) => {
   //    setShowLoader(true);
   //    // запит після пошуку
   //    AxiosInstance.get(`${urlApi}?page=${p}`).then((response) => {
   //       setRows(response.data['hydra:member'])
   //       setRowCountState(response.data['hydra:totalItems'])
   //       setShowLoader(false)
   //    })
   // }


   //оновлена функція з фільтром
   const getRowsTable = (p = 1) => {
      setShowLoader(true)
      let request = ''
      if (partnerFilterSearch !== '' && partnerFilterSearch !== null) request += `&account.name=${partnerFilterSearch.label}`
      if (factoryFilterSearch !== '' && factoryFilterSearch !== null) request += `&factory.id=${factoryFilterSearch.value}`
      if (role === 'ROLE_PARTNER') request += `&account.user.id=${userData.id}`

      AxiosInstance.get(`${urlApi}?page=${p}${request}`).then((response) => {
         setRows(response.data['hydra:member'])
         setRowCountState(response.data['hydra:totalItems'])
         setShowLoader(false)
      })
   }

   //перенесена логіка для  фільтраціі
   const disabledButton = () => {
      setDisabled(
         // (typeof partnerFilterSearch === 'string' && partnerFilterSearch === '') &&
         // factoryFilterSearch === ''
         !partnerFilterSearch && !factoryFilterSearch
      )
   }

   useEffect(() => { disabledButton() }, [partnerFilterSearch, factoryFilterSearch])

   useEffect(() => {
      if (resetFiltersFlag) { getRowsTable(); setResetFiltersFlag(false) }
   }, [resetFiltersFlag])

   const handleFilterSearch = () => { getRowsTable() }

   const handleFilterReset = () => {
      // setPartnerFilterSearch('')
      // setFactoryFilterSearch('') 
      setPartnerFilterSearch(null)
      setFactoryFilterSearch(null)
      setDisabled(true)
      setResetFiltersFlag(true)
   }

   const loadOptions = async (inputValue) => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/accounts?name=${inputValue}`).then((response) => {
            return response.data?.['hydra:member'].map((result) => ({ label: result.name, value: result.id }))
         })
      } else if (userData?.id) {
         return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`).then((response) => {
            return response.data?.['hydra:member'].map((result) => ({ label: result.name, value: result.id }))
         })
      }
   }

   const loadOptionsFactory = async () => {
      return await AxiosInstance.get(`/factories`).then((response) => {
         return response.data?.['hydra:member'].map((result) => ({ label: result.name, value: result.id }))
      })
   }

   //перенесена логіка для фільтраціі


   //Сортування по dateModified при першому заповненні
   // if (!rows && data?.['hydra:member']) {
   //    const sorted = [...data?.['hydra:member']]?.sort((a, b) => {
   //       const aDate = a.dateModified ? dayjs(a.dateModified).valueOf() : 0
   //       const bDate = b.dateModified ? dayjs(b.dateModified).valueOf() : 0
   //       return bDate - aDate
   //    })

   //    setRows(sorted)
   //    setRowCountState(data['hydra:totalItems'])
   // }

   useEffect(() => {
      if (data?.['hydra:member']) {
         const sorted = [...data['hydra:member']].sort((a, b) => {
            const aDate = a.dateModified ? dayjs(a.dateModified).valueOf() : 0
            const bDate = b.dateModified ? dayjs(b.dateModified).valueOf() : 0
            return bDate - aDate
         })
         setRows(sorted)
         setRowCountState(data['hydra:totalItems'])
      }
   }, [data])


   // зміна сторінки
   const handlePageChange = (page) => {
      getRowsTable(page + 1)
   }






   async function deleted(row) {
      try {
         await confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => {
                     AxiosInstance.delete(`${urlApi}/${row.id}`).then(() => {
                        getRowsTable();
                     })
                  },
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }
   }

   // Дані, які навнюються в таблицю
   const columns = [
      { field: 'id', headerName: 'ID', width: 50 },
      {
         field: 'dateEntered',
         headerName: 'Дата створення',
         width: 150,
         renderCell: (params) => {
            return (
               <span>
                  {params.row?.dateEntered ? useConvertToLocalTime(params.row.dateEntered) : "❌"}
               </span>
            )
         },
      },
      {
         field: 'dateModified',
         headerName: 'Дата зміни',
         width: 150,
         renderCell: (params) => {
            return (
               <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  {params.row?.dateModified ? dayjs(params.row.dateModified).local().format('YYYY-MM-DD HH:mm:ss') : "-"}
               </div>
            )
         },
      },

      { field: 'description', headerName: 'Опис', width: 130 },
      { field: 'status', headerName: 'Статус', width: 80 },

      {
         field: 'params.row.account.name',
         headerName: 'Контрагент',
         width: 300,
         renderCell: (params) => {
            return (
               params.row.account.name
            )
         },
      },
      {
         field: 'factory',
         headerName: 'Підрозділ',
         width: 185,
         renderCell: (params) => {
            return (
               <span>
                  {params.row.factory?.name ? params.row.factory.name : ""}
               </span>
            )
         },
      },

      {
         field: 'action',
         headerName: 'Переглянути',
         align: 'center',
         width: 100,
         sortable: false,
         renderCell: (params) => {
            return (
               <Link to={`${urlRouter}/view/${params.row.id}`}>
                  <CButton color="dark" variant="outline">
                     <CIcon icon={cilSearch} customClassName="nav-icon" height={20} />
                  </CButton>
               </Link>
            )
         },
      },
      // {
      //    field: 'delete',
      //    headerName: 'Видалити',
      //    width: 80,
      //    sortable: false,
      //    renderCell: (params) => {
      //       return (
      //          <CButton
      //             color="danger"
      //             variant="outline"
      //             onClick={() => {
      //                deleted(params.row)
      //             }}
      //          >
      //             <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
      //          </CButton>
      //       )
      //    },
      // },
   ]


   return (
      <CRow>
         <CCol xs={12}>
            <CCard className="mb-4">
               {/* блок фільтраціі */}
               <CAccordion flush>
                  <CAccordionItem>
                     <CAccordionHeader><strong>Фільтр</strong></CAccordionHeader>
                     <CAccordionBody>
                        <CRow className="my-3 mx-2">
                           <CCol md={4}>
                              <AsyncSelect
                                 cacheOptions loadOptions={loadOptions} defaultOptions
                                 value={partnerFilterSearch} onChange={(s) => setPartnerFilterSearch(s)}
                                 placeholder="Контрагент" isClearable
                              />
                           </CCol>
                           <CCol md={4}>
                              <AsyncSelect
                                 cacheOptions loadOptions={loadOptionsFactory} defaultOptions
                                 value={factoryFilterSearch} onChange={(s) => setFactoryFilterSearch(s)}
                                 placeholder="Підрозділ" isClearable
                              />
                           </CCol>
                           <CCol md={2} className="d-flex gap-2">
                              <CButton color="secondary" onClick={handleFilterSearch} disabled={disabled}>Пошук</CButton>
                              <CButton color="secondary" variant="outline" onClick={handleFilterReset} disabled={disabled}>X</CButton>
                           </CCol>
                        </CRow>
                     </CAccordionBody>
                  </CAccordionItem>
               </CAccordion>

               {/* блок фільтраціі */}

               <CCardHeader>
                  <strong>Графіки Робіт</strong> <small></small>
               </CCardHeader>
               <CCardBody>
                  <div className='mb-2'>
                     <Link to={`${urlRouter}/create`}>
                        <CButton color="secondary">
                           <CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                           Створити
                        </CButton>
                     </Link>
                  </div>
                  <div style={{ height: 400, width: '100%', }}>
                     <DataGrid
                        rows={rows || []}
                        columns={columns}
                        pageSize={30}
                        rowsPerPageOptions={[30]}
                        pagination
                        rowCount={rowCountState}
                        paginationMode="server"
                        onPageChange={handlePageChange}
                        loading={showLoader}
                     />
                  </div>
               </CCardBody>
            </CCard>
         </CCol >
      </CRow >
   )
}

export default WorkPlans